import { useDispatch } from "react-redux"
import { removeItem } from "../utils/cartSlice"
import { CDN_URL } from "../utils/constants"

const FoodItem = ({ name, price, imageId, description,count,id }) => {
   // const dispatch=useDispatch(removeItem())
  return (
    <div className="flex w-6/12">
      {console.log("name", name)}
      <div>
      <img src={CDN_URL + imageId} className="w-3/12" />
      <span>{name}</span><br/>
      <span>৳{price*count / 100}</span><br/>
      <span>count: {count}</span>
      
      
    </div>
    </div>
  )
}

export default FoodItem
